module.exports = __webpack_public_path__ + "static/media/Stirrer_Pic3_WhiteBG.a3a79cfe.png";